import { SelectionChangedEvent } from "ag-grid-community";
import { CounterCustomerChargeEntity } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeEntity";
import { CounterCustomerChargeMaintenanceConstant } from "presentation/constant/CounterCustomerCharge/CounterCustomerChargeMaintenanceConstant";
import { COUNTER_CUSTOMER_CHARGE_COL_DEF } from "presentation/constant/CounterCustomerCharge/UpdatePaidThroughDateColumnDefinition";
import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { PaidThroughDateState } from "presentation/model/CounterCustomerCharge/CounterCustomerChargeMaintenanceModel";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { convertDateToDateTimeForComponent } from "presentation/utils/timeUtil";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateTimePickerComponent from "presentation/view/components/DateTimePickerComponent";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef, useState } from "react";
import { HPHButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const UpdatePaidThroughDatePanel = () => {
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();
    const COUNTER_CUSTOMER_CHARGE_CONSTANT = CounterCustomerChargeMaintenanceConstant.Detail;
    const { editingEntity, paidThroughDateMap, selectedPaidThroughDateMap } = counterCustomerChargeState;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const messageBarVM = useMessageBarVM();
    const gridRef: any = useRef(null);

    const [anainfoState] = useANAInfoTracked();
    const { operatingUnit } = anainfoState;

    const vaildation = useCallback(() => {
        let isAllowUpdatePaidThroughDate = false;

        counterCustomerChargeState.selectedRows.forEach((entity) => {
            if (operatingUnit === "SAPT" || operatingUnit === "KICT") {
                if (entity.dtlState === "E" || entity.dtlState === "R" || entity.dtlState === "F" || entity.dtlState === "T" || entity.dtlState === "W") {
                    if (entity.chargeType === "ITM" || (entity.chargeType === "CC" && entity.subChargeType === "ITM")
                        || (entity.chargeType === "DEM" && entity.subChargeType === "DEI")
                        || (entity.chargeType === "RFH" && (entity.subChargeType === "PCI" || entity.subChargeType === "PCIH" || entity.subChargeType === "FDC"
                            || ((entity.cntrStatus1 === "IF" || entity.cntrStatus1 === "IM" || entity.cntrStatus1 === "TF" || entity.cntrStatus1 === "TM")
                                && (entity.subChargeType === "T2" || (entity.subChargeType === "T1" && entity.otherSplitId === null)))))
                        || ((entity.chargeType === "CSR") && (entity.subChargeType === "ST" || entity.subChargeType === "DE"))) {
                        isAllowUpdatePaidThroughDate = true;
                    }
                }
            } else {
                if ((entity.dtlState === "E" || entity.dtlState === "R" || entity.dtlState === "F" || (entity.dtlState === "T" && (operatingUnit === "OICT" || operatingUnit === "HPJZ")))) {
                    if ((operatingUnit === "AQCT" || operatingUnit === "RSCT") &&
                        (entity.adjType !== "Cancel Only" && entity.adjType !== "Cancel & Re-bill")) {
                        isAllowUpdatePaidThroughDate = true;
                    } else {
                        isAllowUpdatePaidThroughDate = true;
                    }
                }
            }
        })

        if (operatingUnit !== "SAPT" && operatingUnit !== "KICT") {
            if (!editingEntity.paidThroughDate) {
                messageBarVM.showError("Please input the Paid through date time.");
                return false;
            }
        }

        const currentDate = new Date();//dd-MM-yyyy HH:mm:ss
        if (operatingUnit === "SAPT" || operatingUnit === "KICT") {
            if (editingEntity.paidThroughDate && editingEntity.paidThroughDate < currentDate) {
                messageBarVM.showError("Paid Through Date " + convertDateToDateTimeForComponent(editingEntity.paidThroughDate) + " is not allow back date.");
                return false;
            }
        } else {
            let msg = null;
            paidThroughDateMap.forEach((value, key) => {
                if (!value) {
                    msg = "Please input the Paid Through Date.";
                    return false;
                }
                const paidDate = new Date(value);
                if (paidDate && paidDate < currentDate) {
                    if (operatingUnit === "OICT" || operatingUnit === "HPJZ") {
                        msg = "The Paid through date time should not be earlier than the current system date.";
                    } else {
                        msg = "Paid Through Date " + convertDateToDateTimeForComponent(value) + " is not allow back date.";
                    }
                    return false;
                }
            });
            if (msg) {
                messageBarVM.showError(msg);
                return false;
            }
        }

        if (!isAllowUpdatePaidThroughDate) {
            messageBarVM.showError("Just allow update the paid through date for R/F/E/T storage charge except for outbound storage.");
            return false;
        }

        return true;
    }, [editingEntity.paidThroughDate, counterCustomerChargeState.selectedRows, operatingUnit, messageBarVM, paidThroughDateMap]);

    const handleSaveClick = useCallback(async () => {
        if (!vaildation()) {
            return;
        }
        setIsLoading(true);
        if (operatingUnit === "SAPT" || operatingUnit === "KICT") {
            let entityList: CounterCustomerChargeEntity[] = [];
            counterCustomerChargeState.selectedRows.forEach(item => {
                const cntrNo = item.cntrNo;
                if (cntrNo && paidThroughDateMap && paidThroughDateMap.has(cntrNo)) {
                    item.paidThroughDate = paidThroughDateMap?.get(cntrNo) ?? null;
                }
                entityList.push(item);
            });
            counterCustomerChargeVM.onSave(entityList).then((res) => {
                setIsLoading(false);
                counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria).finally(() => {
                    if (res && res.success) {
                        messageBarVM.showSuccess('Save Successfully.');
                        counterCustomerChargeVM.onMoreClose();
                    } else {
                        messageBarVM.showError('Save Failed.');
                    }
                });
            });
        } else {
            counterCustomerChargeVM.updatePaidThroughDate(paidThroughDateMap).then((res) => {
                setIsLoading(false);
                counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria).finally(() => {
                    if (res && res.success) {
                        messageBarVM.showSuccess('Save Successfully.');
                        counterCustomerChargeVM.onMoreClose();
                    } else {
                        messageBarVM.showError('Save Failed.');
                        counterCustomerChargeVM.onMoreClose();
                    }
                });
            });
        }

    }, [counterCustomerChargeVM, counterCustomerChargeState.selectedRows, messageBarVM, counterCustomerChargeState.searchCriteria, vaildation, paidThroughDateMap, operatingUnit]);

    const handClose = useCallback(() => {
        counterCustomerChargeVM.onMoreClose();
    }, [counterCustomerChargeVM]);

    const allRows = useMemo<PaidThroughDateState[]>(() => {
        if (!paidThroughDateMap || paidThroughDateMap.size === 0) {
            return [];
        }
        return Array.from(paidThroughDateMap)
            .map(([containerNo, paidThroughDate]) => ({
                cntrNo: containerNo,
                paidThroughDate: paidThroughDate,
            }))
            .sort((a, b) => a.cntrNo.localeCompare(b.cntrNo));
    }, [paidThroughDateMap]);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        counterCustomerChargeVM.updateSelectedPaidThroughDateRows(selectedRows);
    }, [counterCustomerChargeVM])

    const handApply = useCallback(() => {
        if (!selectedPaidThroughDateMap || selectedPaidThroughDateMap.size === 0) {
            messageBarVM.showError("Please select record(s).");
            return;
        }
        if (!editingEntity.paidThroughDate) {
            messageBarVM.showError("Please input the Paid through date time.");
            return;
        }
        counterCustomerChargeVM.onApplyClick(paidThroughDateMap, selectedPaidThroughDateMap);
    }, [counterCustomerChargeVM, editingEntity.paidThroughDate, messageBarVM, paidThroughDateMap, selectedPaidThroughDateMap]);

    const updatePaidThroughDatePanelTable =
        <NbisTable
            id='update-paid-through-date-table'
            isNewColumnSetting={false}
            columns={COUNTER_CUSTOMER_CHARGE_COL_DEF?.slice()}
            data={allRows ?? []}
            showPaginator={false}
            editable={false}
            showAddIcon={false}
            showUploadIcon={false}
            showDeleteButton={false}
            showReloadIcon={false}
            selectionMode={false}
            isRowHighligted={true}
            showPreferenceMenu={false}
            showSidebar={false}
            handleSelectionChanged={handleSelectionChange}
            gridHeight="customHeight"
            customHeight="calc(40vh)"
            ref={gridRef}
            rowSelection={"multiple"}
        />

    const memoPaidThroughDate = useMemo(() => {
        if (!paidThroughDateMap || paidThroughDateMap.size === 0) {
            return null;
        }

        return (
            <>
                <CriteriaItemContainer>
                    <div className="im-flex-row-item" style={{ width: "220px", marginBottom: "24px", marginLeft: "15px" }}>
                        <DateTimePickerComponent
                            disabled={false}
                            label={COUNTER_CUSTOMER_CHARGE_CONSTANT.PAID_THROUGH_DATE}
                            width="220px"
                            date={editingEntity?.paidThroughDate}
                            fieldName={"paidThroughDate"}
                            errorMessage=""
                            onDateChange={counterCustomerChargeVM.onCounterCustomerFieldChange}
                        />
                    </div>
                    <HPHButton label={'Apply'} size={'Small'} theme={'Secondary'} onClick={handApply} />
                </CriteriaItemContainer>
            </>
        );
    }, [COUNTER_CUSTOMER_CHARGE_CONSTANT.PAID_THROUGH_DATE, counterCustomerChargeVM, editingEntity?.paidThroughDate, handApply, paidThroughDateMap]);


    return (<div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <HeaderTitle>{"Update Paid Through Date"}</HeaderTitle>
                </Sidebarheader>
            </div>
        </div>

        {isLoading && <Loader Indicator="Spinner" size="Medium" />}

        <div style={{ marginTop: "-50px" }}>
            <TableWrapper>
                <div style={{ marginLeft: "15px" }}>{updatePaidThroughDatePanelTable}</div>
            </TableWrapper>
        </div>

        <div className={'add-edit-form'} style={{ maxHeight: '32vh', height: '32vh', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    {memoPaidThroughDate}
                </div>
            </div>
        </div>
        <SidebarActionBar>
            <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={handClose} />
            <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />
        </SidebarActionBar>
    </div >)
}

export default memo(UpdatePaidThroughDatePanel);